import { ConfiguratorService } from '@/services/sketchfab/index';

export const Types = {
  ConfigurationServiceInitiatedEvent : 'ConfigurationServiceInitiated',
};

export interface ConfigurationServiceInitiated {
  sketchfabModelId:string;
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/events.ts